import Contact_us from "../contact_us/contact_us";
import Services from "../services/services";
import Topbar from "../topbar/topbar";
import Footer from "../Footer/Footer";
import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import img1 from "../../img/hcm1.jpg";
import FooterSec from "../footer_sec/footer_sec";
import ContactSection from "../contact/contact";
import AboutUsHero from "../about_us_hero/about_us_hero"
import PartnershipBadges from "../partners/partners";
import PerfectMatch from "../perfect_match/perfect_match";
import AboutUsContent from "../about_us_content/about_us_content";
import OurPrinciples from "../our_principles/our_principles";
import CeoDetails from "../ceo_details/ceo_details";


export default function AboutUsPage2({openContactModal}) {
  const solutionsAndServicesRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    // Scroll to the solutionsAndServicesRef element if it exists
    if (solutionsAndServicesRef.current) {
      solutionsAndServicesRef.current.scrollIntoView({ behavior: "auto" });
    }
  }, [location]);

  const handleGoBack = () => {
    window.history.back(); // Go back in the browser's history
  };
  return (
    <div id="about_us">
      {/* <TopBar /> */}

      <Topbar />
      <AboutUsHero />
      <AboutUsContent />
      <OurPrinciples />
      <CeoDetails/>
     
      <ContactSection openContactModal={openContactModal} />
      <FooterSec />
    </div>
  );
}
